import { GetterTree } from 'vuex';
import { CommentModel, CommentInfo } from '@descomplica/dex-models';
import { CommentState } from './state';
import RootState from '@/store/root_state';
import { UnifiedCommentModel } from '@/models/UnifiedCommentModel';

const getters: GetterTree<CommentState, RootState> = {
  commentsByQuestionId: (state, commentsGetters) => (questionId: number) => {
    return Object.values(state.comments)
      .map((comment: CommentInfo) => new CommentModel(comment, commentsGetters))
      .filter((comment) => comment.questionId === questionId)
      .map((comment) => new UnifiedCommentModel(comment));
  },

  commentScoreUpdatingStatus: (state) => (commentId: number) =>
    state.isUpdatingCommentScore[commentId] || false,
};

export default getters;
